import {useCallback, useState} from 'react';

/**
 * Shows a loading skeleton in place of a field's value while `loading` is true,
 * until the user focuses the field while it's loading — which reveals it permanently
 * for manual entry, even if `loading` is still true (e.g. a value is still being
 * generated elsewhere). Focusing an idle (not currently loading) field is a no-op,
 * so a later loading period for the same field still shows its skeleton.
 *
 * @example
 * const {showSkeleton, onFocus} = useSkeletonReveal(isLoading);
 * {showSkeleton && <Skeleton />}
 * <input onFocus={onFocus} .../>
 */
export function useSkeletonReveal(loading?: boolean) {
  const [revealed, setRevealed] = useState(false);
  const onFocus = useCallback(() => {
    if (loading) setRevealed(true);
  }, [loading]);

  return {showSkeleton: !!loading && !revealed, onFocus};
}
